import templateUrl from "./support.component.html";

export const SupportComponent = {
    templateUrl
}
